export const validateTemplate = (form: any, visible: boolean) => {
  const budgetUsdFrom = Number(form.budget_usd_from);
  const budgetUsdTo = Number(form.budget_usd_to);
  const hasValidBudget =
    Number.isFinite(budgetUsdFrom) &&
    Number.isFinite(budgetUsdTo) &&
    budgetUsdFrom >= 1 &&
    budgetUsdTo >= budgetUsdFrom;

  const selectedMarketingFormats = Array.isArray(form.marketing_image_formats)
    ? form.marketing_image_formats
    : [];
  const hasRequiredMarketingFormat =
    selectedMarketingFormats.includes('square') ||
    selectedMarketingFormats.includes('landscape');

  return (
    !!form.name &&
    !!form.descriptions?.length &&
    !!form.headlines?.length &&
    hasValidBudget &&
    !!form.logo?.length &&
    (visible 
      ? !!form.marketing_link?.length 
      : ((!!form.source_image?.length && selectedMarketingFormats.length > 0 && hasRequiredMarketingFormat) ||
         !!form.marketing_image?.length ||
         !!form.marketing_image_square?.length ||
         !!form.marketing_image_landscape?.length)
    )
  );
};
